import React, {Component} from 'react';
import LocationComponent from 'components/LocationComponent/LocationComponent';
import './LocationComponentList.scss';

class LocationComponentList extends Component {
    constructor(props) {
        super(props);
        this.itemRefs = {};
    }

    componentDidMount() {
        this.scrollToTheFistIncompleted();
    }

    scrollToTheFistIncompleted = () => {
        const firstIncompleted = this.props.stays.find((item) => !item.Submission.IsComplete);
        const scrollOptions = {
            behavior: 'smooth',
            block: 'start'
        };

        firstIncompleted
            ? this.itemRefs[firstIncompleted.StayId].scrollIntoView(scrollOptions)
            : this.itemRefs['overall'].scrollIntoView(scrollOptions);
    }
    /**
     * Returns our list of location components based on the supplied props.
     */
    locations = () => this.props.stays.map((stay, index) => {
        const isStayAvailable = stay.Submission.IsAvailable;

        return (
            <LocationComponent
                childRef={(el) => (this.itemRefs[stay.StayId] = el)}
                actions={this.props.actions}
                endDate={stay.EndDate}
                index={index}
                isAvailable={isStayAvailable}
                isComplete={stay.Submission.IsComplete && isStayAvailable}
                isInProgress={stay.Submission.IsInProgress && isStayAvailable}
                startDate={stay.StartDate}
                name={stay.StayName}
                nextPage='/PulseCheck'
            />
        );
    });


    render() {
        const isOverallAvailable = this.props.overallSubmission.Submission.IsAvailable;

        return (
            <ul className='location-list'>
                {this.locations()}
                <LocationComponent
                    childRef={(el) => (this.itemRefs['overall'] = el)}
                    actions={this.props.actions}
                    index={this.props.stays.length}
                    isAvailable={isOverallAvailable}
                    isComplete={this.props.overallSubmission.Submission.IsComplete && isOverallAvailable}
                    isInProgress={this.props.overallSubmission.Submission.IsInProgress && isOverallAvailable}
                    name='Overall Experience'
                    nextPage='/NPS'
                />
            </ul>
        );
    }
};

export default LocationComponentList;



// WEBPACK FOOTER //
// ./application/components/LocationComponentList/LocationComponentList.jsx